import { render, staticRenderFns } from "./bindChannel.vue?vue&type=template&id=cf28f668&scoped=true"
import script from "./bindChannel.vue?vue&type=script&lang=js"
export * from "./bindChannel.vue?vue&type=script&lang=js"
import style0 from "./bindChannel.vue?vue&type=style&index=0&id=cf28f668&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf28f668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf28f668')) {
      api.createRecord('cf28f668', component.options)
    } else {
      api.reload('cf28f668', component.options)
    }
    module.hot.accept("./bindChannel.vue?vue&type=template&id=cf28f668&scoped=true", function () {
      api.rerender('cf28f668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsChannel/bindChannel.vue"
export default component.exports